import { render, staticRenderFns } from "./QiehuandianpuBianji.vue?vue&type=template&id=36cb3a6e&"
import script from "./QiehuandianpuBianji.vue?vue&type=script&lang=js&"
export * from "./QiehuandianpuBianji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./QiehuandianpuBianji.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=Yangshi.css"
if (typeof block0 === 'function') block0(component)

export default component.exports